"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormBase = void 0;

var react_1 = __importDefault(require("react"));

var typings_1 = require("../../typings");

var typography_1 = require("../typography");

var FormBase = function FormBase(_a) {
  var children = _a.children,
      label = _a.label,
      legend = _a.legend,
      error = _a.error,
      theme = _a.theme,
      htmlFor = _a.htmlFor,
      _b = _a.orientation,
      orientation = _b === void 0 ? typings_1.Orientation.left : _b;
  var style = "flex flex-col " + (orientation === typings_1.Orientation.right ? 'text-right' : 'text-left');
  return react_1["default"].createElement("div", {
    className: style
  }, legend && react_1["default"].createElement(typography_1.Legend, {
    theme: theme
  }, legend), label && react_1["default"].createElement(typography_1.Label, {
    theme: theme,
    htmlFor: htmlFor
  }, label), children, error && react_1["default"].createElement(typography_1.Error, {
    theme: theme
  }, error));
};

exports.FormBase = FormBase;